import { MagicConfigMixin } from '@gig/magic-common';
import { __extends, __decorate, __metadata } from 'tslib';
import { Emit, Component, Mixins } from 'vue-property-decorator';
import cookies from 'js-cookie';

var COOKIE_POLICY_ACCEPTED = 'cookie-policy-accepted';
var CookiePopupNotificationComponent = /** @class */ (function (_super) {
    __extends(CookiePopupNotificationComponent, _super);
    function CookiePopupNotificationComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CookiePopupNotificationComponent.prototype.cookiesAccepted = function () {
        cookies.set(COOKIE_POLICY_ACCEPTED, 'true', { expires: 365 });
        return;
    };
    CookiePopupNotificationComponent.prototype.cookiesRejected = function () {
        // We don't set a cookie when rejected
    };
    __decorate([
        Emit('close'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], CookiePopupNotificationComponent.prototype, "cookiesAccepted", null);
    __decorate([
        Emit('close'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], CookiePopupNotificationComponent.prototype, "cookiesRejected", null);
    CookiePopupNotificationComponent = __decorate([
        Component({ name: 'cookie-popup-notification' })
    ], CookiePopupNotificationComponent);
    return CookiePopupNotificationComponent;
}(Mixins(MagicConfigMixin)));

export default CookiePopupNotificationComponent;
